import {
  Button,
  Modal,
} from "@heroui/react";
import { useState } from "react";
import { Icon } from "@iconify/react";

import { useDeleteDirection } from "@/features/directions/use-directions.ts";

export function DeleteDirectionModal({ directionId }: { directionId: number }) {
  const [isOpen, setIsOpen] = useState(false);
  const { mutateAsync, isPending } = useDeleteDirection({});

  return (
    <>
      <Button
        isIconOnly
        variant="danger-soft"
        onPress={() => setIsOpen(true)}
      >
        <Icon className="size-6" icon="solar:trash-bin-minimalistic-bold" />
      </Button>

      <Modal isOpen={isOpen} onOpenChange={setIsOpen}>
        <Modal.Backdrop isDismissable>
          <Modal.Container placement="center">
            <Modal.Dialog>
              <Modal.Header>
                <Modal.Heading>Подтверждение</Modal.Heading>
              </Modal.Header>
              <Modal.Body>Удалить направление?</Modal.Body>
              <Modal.Footer>
                <Button
                    variant="ghost"
                    onPress={() => setIsOpen(false)}
                >
                  Нет, назад
                </Button>

                <Button
                    variant="danger"
                    isPending={isPending}
                    type="submit"
                    onPress={() => mutateAsync({ id: directionId })}
                >
                  Да, удалить
                </Button>
              </Modal.Footer>
            </Modal.Dialog>
          </Modal.Container>
        </Modal.Backdrop>
      </Modal>
    </>
  );
}
